/*
 * @Author: miaoqing6
 * @Date: 2025-03-03 16:21:00
 * @LastEditors: miaoqing6
 * @Date: 2025-03-03 16:21:00
 * @Description: file content
 */
import dayjs from 'dayjs';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';

@BindAll()
export class BusinessPriceQuotationReviewListController<
  T = any,
> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.businessPriceQuotationReviewList_search,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        response: {
          total: 'total',
          dataSource: 'records',
          valueGetter: this.valueGetter,
        },
      },
    });
  }
  valueGetter(res) {
    // const dataSource = lodash.map(lodash.get(res, 'records'), (item) => {
    //   const status = item.status != 8 ? item.status : item.reviewBeforeStatus;
    //   return lodash.assign(item, {
    //     _status: lodash.get(this.statusEnum, status),
    //   });
    // });
    const dataSource = lodash.get(res, 'records').map((item) => {
      const perItem = [];
      perItem.push({ label: 'id', value: item.id, isShow: false });
      perItem.push({
        label: '报价单编号',
        value: item.priceCode,
        isShow: false,
      });
      perItem.push({ label: '经销商编号', value: item.providerCode });
      perItem.push({ label: '经销商名称', value: item.providerName });
      perItem.push({ label: '总数量', value: item.number });
      perItem.push({ label: '总价格(元)', value: item.price });
      perItem.push({ label: '审核用时', value: this.getTime(item) });
      perItem.push({
        label: 'reviewVersion',
        value: item.reviewVersion,
        isShow: false,
      });
      // perItem.push({
      //   label: '审核状态',
      //   value: this.getStatus(item.reviewStatus),
      // });
      perItem.push({ label: '提交时间', value: item.submitTime });
      perItem.push({
        label: 'isEnabled',
        value: item.isEnabled,
        isShow: false,
      });
      perItem.push({
        label: 'reviewStatus',
        value: item.reviewStatus,
        isShow: false,
      });
      return perItem;
    });
    const total = lodash.get(res, 'total');
    return {
      dataSource,
      total,
    };
  }

  getStatus = (text) => {
    switch (text) {
      case '0':
        return '待审核';
      case '1':
        return '已审核';
      default:
        return text;
    }
  };

  getTime = (record) => {
    const date1 = dayjs(record.submitTime);
    let date2: any;

    if (record.reviewTime) {
      date2 = dayjs(record.reviewTime);
    } else if (record.disableTime) {
      date2 = dayjs(record.disableTime);
    } else {
      date2 = dayjs();
    }

    let hours = date2.diff(date1, 'hours');
    const days = Math.floor(hours / 24);
    hours = hours - days * 24;
    const minutes = date2.diff(date1, 'minutes') - days * 24 * 60 - hours * 60;
    let str = `${this.parseDigits(hours)}时${this.parseDigits(minutes)}分`;
    if (days) {
      return `${this.parseDigits(days)}天` + str;
    }
    return str;
  };
  parseDigits = (num) => {
    return num < 10 ? `0${num}` : num;
  };
  /**
   * @des 状态枚举
   */
  statusEnum = {
    '0': '草稿',
    '1': '已提交',
    '2': '跟进中',
    '3': '持续跟进',
    '4': '已关闭',
    '5': '已提交bidding',
    '6': '已生成报价单',
    '7': '已转订单',
  };

  /**
   * @des 复制商机
   */
  async onBusinessCopyBus(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_copyBus,
      body,
    });
  }

  /**
   * @des 获取报价单审核详情
   */
  async getPriceQuotationReviewDetail(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_priceQuotationReview_detail,
      body,
    });
  }
}
